import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M4.996 2.084a.75.75 0 0 0-.75.75v1.533h7.508v-.742a.75.75 0 0 0-.228-.539l-.815-.79a.75.75 0 0 0-.522-.212zm8.258 2.285v-.744a2.25 2.25 0 0 0-.684-1.616l-.815-.79a2.25 2.25 0 0 0-1.566-.635H4.996a2.25 2.25 0 0 0-2.25 2.25v1.535A2.25 2.25 0 0 0 .584 6.617v2.766a2.25 2.25 0 0 0 2.162 2.248v1.535a2.25 2.25 0 0 0 2.25 2.25h6.008a2.25 2.25 0 0 0 2.25-2.25v-1.535a2.25 2.25 0 0 0 2.162-2.248V6.617a2.25 2.25 0 0 0-2.162-2.248M2.746 9.622v.506a.75.75 0 0 1-.662-.745V6.617a.75.75 0 0 1 .75-.75h10.332a.75.75 0 0 1 .75.75v2.766a.75.75 0 0 1-.662.745v-.506a.75.75 0 0 0-.75-.75H3.496a.75.75 0 0 0-.75.75m1.5.75v2.794c0 .415.335.75.75.75h6.008a.75.75 0 0 0 .75-.75v-2.794z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }